import { render, staticRenderFns } from "./typeAndCont.vue?vue&type=template&id=1af43e33&scoped=true"
import script from "./typeAndCont.vue?vue&type=script&lang=js"
export * from "./typeAndCont.vue?vue&type=script&lang=js"
import style0 from "./typeAndCont.vue?vue&type=style&index=0&id=1af43e33&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af43e33",
  null
  
)

export default component.exports